import Styles from '../../../assets/style.scss';
import { IPLabelProps } from '../../../entities';

const IPLabel = (props: IPLabelProps) => (
	<p
		className={Styles.borderLabel}
		style={props.style}
	>
		{props.label}
	</p>
);
export default IPLabel;
